export default __webpack_public_path__ + "static/parent-pack-cc585dd64c8f2b96e85667efc1f56559.png";